<template>
  <div class="sa-giving-metrics-skeleton" aria-hidden="true">
    <div v-for="index in 3" :key="index" class="sa-metric-card sa-giving-metrics-skeleton__card">
      <div class="sa-giving-metrics-skeleton__label sa-skeleton" />
      <div class="sa-giving-metrics-skeleton__value sa-skeleton" />
      <div class="sa-giving-metrics-skeleton__sub sa-skeleton" />
    </div>
  </div>
</template>
